
import BulletList from "../../../assets/filled/BulletList.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BulletListIcon({ className, dataTestid = "BulletListIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BulletList data-testid={dataTestid} className={classes} {...rest} />
  );
}
